module.exports = __webpack_public_path__ + "static/muesli-mania-8d9197663545686062e25954b5f72134.svg";